export const UNLOAD_SURVEY = 'UNLOAD_SURVEY';
